/**
 * Door Listing - Filters and Infinite Scroll
 */

jQuery(document).ready(function ($) {
  let currentPage = 1;
  let isLoading = false;
  let hasMore = true;
  let infiniteScrollEnabled = false; // Track if infinite scroll should be enabled
  let isFirstLoad = true; // Track if it's the first load

  // Initialize
  init();

  function init() {
    // Set header height CSS variable for back-to-top button positioning
    updateHeaderHeight();
    // Ensure filters default state (collapsed on mobile)
    setFiltersDefaultState();
    $(window).on("resize", function () {
      updateHeaderHeight();
      setFiltersDefaultState();
    });

    // Apply URL parameters to filters if present
    applyUrlFilters();

    // Load initial doors
    loadDoors(true);

    // Filter toggle (works on all screen sizes)
    $(".filter-toggle").on("click", toggleFilters);

    // Search input with debounce
    let searchTimeout;
    $("#door-search-input").on("input", function () {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        currentPage = 1;
        loadDoors(true);
      }, 500);
    });

    // Price icon selection
    $(".price-icon").on("click", function () {
      const selectedPrice = $(this).data("price");
      const currentPrice = $("#filter-price").val();

      // Toggle: if clicking the same level, deselect it
      if (currentPrice == selectedPrice) {
        $("#filter-price").val(0);
        updatePriceIcons(0);
      } else {
        $("#filter-price").val(selectedPrice);
        updatePriceIcons(selectedPrice);
      }
    });

    // Security icon selection
    $(".security-icon").on("click", function () {
      const selectedSecurity = $(this).data("security");
      const currentSecurity = $("#filter-security").val();

      // Toggle: if clicking the same level, deselect it
      if (currentSecurity == selectedSecurity) {
        $("#filter-security").val(0);
        updateSecurityIcons(0);
      } else {
        $("#filter-security").val(selectedSecurity);
        updateSecurityIcons(selectedSecurity);
      }
    });

    // Apply filters button
    $("#apply-filters-btn").on("click", function () {
      currentPage = 1;
      loadDoors(true);
    });

    // Reset filters button
    $("#reset-filters-btn").on("click", function () {
      // Reset all filters
      $("#door-search-input").val("");
      $("#filter-materiaux").val("");
      $("#filter-styles").val("");
      $("#filter-vitrage").val("");
      $("#filter-price").val(0);
      $("#filter-security").val(0);

      // Reset price icons
      updatePriceIcons(0);

      // Reset security icons
      updateSecurityIcons(0);

      // Reset page and load doors
      currentPage = 1;
      loadDoors(true);
    });

    // Load more button
    $("#load-more-btn").on("click", function () {
      if (!isLoading && hasMore) {
        // Enable infinite scroll after first manual click
        infiniteScrollEnabled = true;
        currentPage++;
        loadDoors(false);
      }
    });

    // Infinite scroll (only active after first "Load more" click)
    $(window).on("scroll", function () {
      if (
        infiniteScrollEnabled &&
        !isLoading &&
        hasMore &&
        $("#doors-grid").length &&
        $(window).scrollTop() + $(window).height() >=
          $("#doors-grid").offset().top + $("#doors-grid").height() - 500
      ) {
        currentPage++;
        loadDoors(false);
      }
    });

    // Back to top button (appears when header passes filters panel)
    const $backToTop = $("#back-to-top-btn");
    const $filtersPanel = $(".door-filters");
    const $header = $("#main-header");

    $(window).on("scroll", function () {
      if ($filtersPanel.length && $header.length) {
        const filtersPanelBottom =
          $filtersPanel.offset().top + $filtersPanel.outerHeight();
        const headerBottom = $header.outerHeight();
        const scrollTop = $(window).scrollTop();

        // Show button when header bottom passes filters panel bottom
        if (scrollTop + headerBottom > filtersPanelBottom) {
          $backToTop.removeClass("hidden");
        } else {
          $backToTop.addClass("hidden");
        }
      }
    });

    $backToTop.on("click", function () {
      const $filtersPanel = $(".door-filters");
      if ($filtersPanel.length) {
        // Scroll to filters panel
        $("html, body").animate(
          {
            scrollTop:
              $filtersPanel.offset().top - $("#main-header").outerHeight(),
          },
          600,
        );

        // Open filters on mobile if they're closed
        if ($(window).width() < 1024) {
          const $content = $(".filters-content");
          const isOpen = $content.data("open");

          if (!isOpen) {
            const $toggle = $(".filter-toggle svg");
            $content.data("open", true);
            const contentHeight = $content.prop("scrollHeight");
            $content.css("max-height", contentHeight + "px");
            $toggle.addClass("rotate-180");
            $(".filter-toggle").attr("aria-expanded", "true");
          }
        }
      }
    });
  }



  function updateHeaderHeight() {
    const $header = $("#main-header");
    if ($header.length) {
      const headerHeight = $header.outerHeight();
      $("#back-to-top-btn").css("top", headerHeight + "px");
    }
  }

  // Collapse filters header by default on mobile (<1024px), expand on desktop
  function setFiltersDefaultState() {
    const $content = $(".filters-content");
    const $toggle = $(".filter-toggle svg");

    if (!$content.length) return;

    if ($(window).width() < 1024) {
      $content.data("open", false);
      $content.css("max-height", "0");
      $toggle.removeClass("rotate-180");
      $(".filter-toggle").attr("aria-expanded", "false");
    } else {
      // desktop: ensure opened by default
      $content.data("open", true);
      const contentHeight = $content.prop("scrollHeight");
      $content.css("max-height", contentHeight + "px");
      $toggle.addClass("rotate-180");
      $(".filter-toggle").attr("aria-expanded", "true");
    }
  }

  function applyUrlFilters() {
    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Apply materiaux filter
    const materiaux = urlParams.get("materiaux");
    if (materiaux) {
      $("#filter-materiaux").val(materiaux);
    }

    // Apply styles filter
    const styles = urlParams.get("styles");
    if (styles) {
      $("#filter-styles").val(styles);
    }

    // Apply vitrage filter
    const vitrage = urlParams.get("vitrage");
    if (vitrage) {
      $("#filter-vitrage").val(vitrage);
    }

    // Apply price filter
    const price = urlParams.get("price");
    if (price) {
      const priceLevel = parseInt(price);
      if (priceLevel >= 1 && priceLevel <= 5) {
        $("#filter-price").val(priceLevel);
        updatePriceIcons(priceLevel);
      }
    }

    // Apply security filter
    const security = urlParams.get("security");
    if (security) {
      const securityLevel = parseInt(security);
      if (securityLevel >= 1 && securityLevel <= 5) {
        $("#filter-security").val(securityLevel);
        updateSecurityIcons(securityLevel);
      }
    }

    // Apply search filter
    const search = urlParams.get("search");
    if (search) {
      $("#door-search-input").val(decodeURIComponent(search));
    }
  }

  function toggleFilters() {
    const $content = $(".filters-content");
    const $toggle = $(".filter-toggle svg");
    const isOpen = $content.data("open");

    if (isOpen) {
      $content.data("open", false);
      $content.css("max-height", "0");
      $toggle.removeClass("rotate-180");
      $(".filter-toggle").attr("aria-expanded", "false");
    } else {
      $content.data("open", true);
      const contentHeight = $content.prop("scrollHeight");
      $content.css("max-height", contentHeight + "px");
      $toggle.addClass("rotate-180");
      $(".filter-toggle").attr("aria-expanded", "true");
    }
  }

  function updatePriceIcons(level) {
    $(".price-icon").each(function (index) {
      const iconLevel = index + 1;
      const $svg = $(this).find(".price-svg path");

      if (iconLevel <= level) {
        $svg.attr("fill", "#189D95"); // Filled
      } else {
        $svg.attr("fill", "#D1D2D5"); // Empty
      }
    });
  }

  function updateSecurityIcons(level) {
    $(".security-icon").each(function (index) {
      const iconLevel = index + 1;
      const $svg = $(this).find(".security-svg path");

      if (iconLevel <= level) {
        $svg.attr("fill", "#189D95"); // Filled
      } else {
        $svg.attr("fill", "#D1D2D5"); // Empty
      }
    });
  }

  function getFilters() {
    const priceValue = parseInt($("#filter-price").val()) || 0;
    const securityValue = parseInt($("#filter-security").val()) || 0;

    return {
      search: $("#door-search-input").val(),
      materiaux: $("#filter-materiaux").val(),
      styles: $("#filter-styles").val(),
      vitrage: $("#filter-vitrage").val(),
      price: priceValue,
      security: securityValue,
    };
  }

  function updateUrlWithFilters(filters) {
    const params = new URLSearchParams();

    if (filters.search) params.set("search", filters.search);
    if (filters.materiaux) params.set("materiaux", filters.materiaux);
    if (filters.styles) params.set("styles", filters.styles);
    if (filters.vitrage) params.set("vitrage", filters.vitrage);
    if (filters.price > 0) params.set("price", filters.price);
    if (filters.security > 0) params.set("security", filters.security);

    const newUrl = params.toString()
      ? window.location.pathname + "?" + params.toString()
      : window.location.pathname;

    window.history.pushState({}, "", newUrl);
  }

  function loadDoors(reset) {
    if (isLoading) return;
    isLoading = true;

    const filters = getFilters();

    if (reset) {
      $("#doors-grid").empty();
      $("#load-more-btn").show();
      // Update URL with current filters
      updateUrlWithFilters(filters);
    }

    $("#doors-loading").removeClass("hidden");

    $.ajax({
      url: doorListingData.ajaxUrl,
      type: "POST",
      data: {
        action: "filter_doors",
        nonce: doorListingData.nonce,
        page: currentPage,
        filters: filters,
      },
      success: function (response) {
        if (response.success) {
          const data = response.data;

          if (data.doors && data.doors.length > 0) {
            if (reset) {
              $("#doors-grid").html(data.doors);
            } else {
              $("#doors-grid").append(data.doors);
            }

            hasMore = data.has_more;

            if (!hasMore) {
              $("#load-more-btn").hide();
            }
          } else {
            if (reset) {
              $("#doors-grid").html(
                '<p class="col-span-full text-center text-gray-500 py-10">Aucune porte ne correspond à vos critères.</p>',
              );
            }
            hasMore = false;
            $("#load-more-btn").hide();
          }
        } else {
          console.error("Error loading doors:", response);
        }

        $("#doors-loading").addClass("hidden");
        isLoading = false;

        // Move loading indicator below grid after first load
        if (isFirstLoad) {
          isFirstLoad = false;
          $("#doors-loading").insertAfter("#doors-grid");
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", error);
        $("#doors-loading").addClass("hidden");
        isLoading = false;

        // Move loading indicator below grid after first load even on error
        if (isFirstLoad) {
          isFirstLoad = false;
          $("#doors-loading").insertAfter("#doors-grid");
        }
      },
    });
  }
});
